<template>
    <a-card :bordered="false" class="header-solid h-full p-10" :bodyStyle="{ padding: 0 }">
        <div class="cardContainer">
            <div>
                <div class="haibaoContainer2" :style="{ width: width + 'px' }" ref="captureArea">
                    <a-result title="请点击右侧选择图片按钮，选择需要添加水印的图片"
                        sub-title='Please click the "Select Image" button on the right and choose the image that needs to be watermarked'
                        v-if="!imageSrc">
                    </a-result>
                    <img v-else :src="imageSrc" alt="">
                </div>
                <!-- <img ref="captureAreaImage" :src="imageSrc" style="width: 2000px;"></img> -->
            </div>
            <div :style="{ width: 'calc(100% - ' + width + 'px)' }">
                <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-form-item label="选择图片">
                        <!-- <a-button @click="uploadimg">点击选择图片</a-button> -->
                        <a-upload-dragger name="file" :multiple="false" :transformFile="customRequest">
                            <p class="ant-upload-drag-icon">
                                <a-icon type="inbox" />
                            </p>
                            <p class="ant-upload-text">
                                单击或拖动文件到此区域进行上传
                            </p>
                            <p class="ant-upload-hint">
                                仅支持jpg、png、jpeg格式图片
                            </p>
                        </a-upload-dragger>
                    </a-form-item>
                    <a-form-item label="画布宽度">
                        <a-input-number v-model="width" :min="300" :max="1300" style="width: 100%;" />
                    </a-form-item>
                    <a-form-item label="水印颜色">
                        <el-color-picker v-model="fontColor" @change="changeOptions"></el-color-picker>
                    </a-form-item>
                    <a-form-item label="水印透明度">
                        <a-slider v-model="globalAlpha" @afterChange="changeOptions" :min="0" :max="1" :step="0.1" />
                    </a-form-item>
                    <a-form-item label="水印文字大小">
                        <a-input-number v-model="fontSize" :min="8" :max="36" :step="1" @blur="changeOptions" />
                    </a-form-item>
                    <a-form-item label="水印显示">
                        <a-switch v-model="shuiyinswitch" @change="changeSuitch" />
                    </a-form-item>
                    <a-form-item label="水印文案">
                        <a-input v-model="shuiyintext" placeholder="水印文案" @blur="changeOptions"></a-input>
                    </a-form-item>
                    <a-form-item label="清晰度倍率">
                        <a-input v-model="beishu" placeholder=""></a-input>
                    </a-form-item>
                    <a-form-item label="操作">
                        <a-button type="primary" :loading="exportLoading" @click="exportImage">导出为图片</a-button>
                    </a-form-item>
                    <a-form-item label="提示">
                        <a-alert message="导出图片如果模糊的话，请将【清晰度倍率】设置为4或以上，再导出，不要太高，会导出很久很久～" type="info" show-icon class="mb-5" />
                    </a-form-item>
                </a-form>
            </div>
        </div>
        <input type="file" id="imageInput" @change="changefile" hidden accept="image/*" />
    </a-card>
</template>
<script>
import draggable from "vuedraggable";
import { Watermark } from "watermark-js-plus";
import html2canvas from "html2canvas";
import "element-ui/lib/theme-chalk/index.css";
export default {
    components: { draggable },
    data() {
        return {
            exportLoading: false,
            width: 800,
            imageSrc: "",
            xuxian: true,
            watermark: null,
            shuiyinswitch: true,
            shuiyintext: "水印文案",
            fontColor: '#FFA500',
            globalAlpha: 0.5,
            fontSize: 14,
            DataList: [
                {
                    type: 'text',
                    value: '文案标题1'
                },
                {
                    type: 'text',
                    value: '文案标题2(出行日期:XX月XX日-XX月XX日)'
                },
                {
                    type: 'images',
                    value: []
                },
                {
                    type: 'line'
                }
            ],
            imageIndex: null,
            beishu: 2
        }
    },
    mounted() {
        this.watermark = new Watermark();
        this.changeOptions()
        this.watermark.create()
    },
    methods: {
        onEnd(event) {
            console.log("排序后的 items:", this.DataList);
        },
        changeSuitch(e) {
            if (e) {
                this.watermark.create();
            } else {
                this.watermark.destroy()
            }
        },
        changeOptions() {
            this.watermark.changeOptions({
                content: this.shuiyintext,
                fontSize: this.fontSize + "px",
                globalAlpha: this.globalAlpha,
                width: 150,
                height: 150,
                translateX: 10,
                fontColor: this.fontColor,
                parent: ".haibaoContainer2",
            })
        },
        uploadimg(imageIndex) {
            this.imageIndex = imageIndex
            document.getElementById('imageInput').click();
        },
        customRequest(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imageSrc = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        changefile(event) {
            const file = event.target.files[0];
            if (file) {
                console.log("图片名称:", file);
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageSrc = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                console.log("未选择图片");
            }
            document.getElementById('imageInput').value = '';
        },
        //导出为图片
        exportImage() {
            this.exportLoading = true
            setTimeout(async () => {
                const element = this.$refs.captureArea;
                // 使用 html2canvas 将 DOM 转换为图片
                const canvas = await html2canvas(element, {
                    dpi: 700, // 解决生产图片模糊
                    scale: parseFloat(this.beishu), // 放大倍数，生成更高分辨率的图片
                    backgroundColor: null, // 设置背景为透明
                });
                const imageDataUrl = canvas.toDataURL("image/png");
                // 下载图片
                const link = document.createElement("a");
                link.href = imageDataUrl;
                link.download = "capture_with_watermark.png";
                link.click();
                this.exportLoading = false
            }, 500);
        }
    }
}
</script>
<style scoped lang="scss">
.cardContainer {
    display: flex;
}

.haibaoContainer2 {
    position: relative;
    display: inline-block;
    // display: flex;
    // border: 1px solid #CCC;
    // background: #e7f5fe;
    // min-height: calc(100vh - 110px);
    min-width: 300px;
    margin-right: 20px;
    // padding: 40px 20px;
    box-sizing: border-box;
    // height: auto;
    // border: 1px solid red;

    img {
        // object-fit: contain;
        width: 100%;
        height: auto;
    }
}
</style>